"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HoverTooltip = void 0;
var _tooltip = require("@design/ui/tooltip");
var _jsxRuntime = require("react/jsx-runtime");
var HoverTooltip = exports.HoverTooltip = function HoverTooltip(_ref) {
  var content = _ref.content,
    children = _ref.children,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? "bottom" : _ref$side,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? "center" : _ref$align,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "inline-flex" : _ref$className,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    _ref$focusable = _ref.focusable,
    focusable = _ref$focusable === void 0 ? true : _ref$focusable,
    _ref$delayDuration = _ref.delayDuration,
    delayDuration = _ref$delayDuration === void 0 ? 0 : _ref$delayDuration;
  if (!active) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: children
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.TooltipProvider, {
    delayDuration: delayDuration,
    "data-sentry-element": "TooltipProvider",
    "data-sentry-component": "HoverTooltip",
    "data-sentry-source-file": "hover-tooltip.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tooltip.Tooltip, {
      "data-sentry-element": "Tooltip",
      "data-sentry-source-file": "hover-tooltip.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.TooltipTrigger, {
        asChild: true,
        "data-sentry-element": "TooltipTrigger",
        "data-sentry-source-file": "hover-tooltip.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: className,
          tabIndex: focusable ? 0 : undefined,
          children: children
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.TooltipContent, {
        side: side,
        align: align,
        "data-sentry-element": "TooltipContent",
        "data-sentry-source-file": "hover-tooltip.tsx",
        children: content
      })]
    })
  });
};